import toast from 'react-hot-toast';
import { TOAST_SURFACE } from '../components/ds/toast';
import { ApiV2Error, ArchiveResult } from './apiV2';

/**
 * Downloads a .zip the API builds on demand: asks until it is READY, then
 * opens the short-lived link. Used by the code viewer and the Deployments
 * list. Resolves once the download started or the failure was shown.
 */

const ARCHIVE_POLL_MS = 1500;
const ARCHIVE_POLL_ATTEMPTS = 80;

export const openUrl = (url: string) => {
  const anchor = document.createElement('a');
  anchor.href = url;
  anchor.rel = 'noopener';
  document.body.appendChild(anchor);
  anchor.click();
  anchor.remove();
};

export const downloadArchive = async (ask: () => Promise<ArchiveResult>) => {
  try {
    for (let attempt = 0; attempt < ARCHIVE_POLL_ATTEMPTS; attempt++) {
      const result = await ask();
      if (result.status === 'READY') {
        openUrl(result.url);
        return;
      }
      await new Promise((resolve) => setTimeout(resolve, ARCHIVE_POLL_MS));
    }
    toast.error('The .zip is taking longer than expected. Try again in a minute.', { className: TOAST_SURFACE });
  } catch (e) {
    toast.error(
      e instanceof ApiV2Error && e.status > 0 && e.status < 500 ? e.message : 'The .zip could not be prepared.',
      { className: TOAST_SURFACE }
    );
  }
};
